export const STICKY_HEADER_SHADOW =
  '0 1px 2px rgb(15 23 42 / 6%), 0 4px 12px -3px rgb(15 23 42 / 10%)';
